import * as React from 'react'

function SvgZw(props) {
	return (
		<svg viewBox="0 0 252 126" width="1em" height="1em" {...props}>
			<path fill="#319208" d="M0 0h252v126H0z" />
			<path fill="#FFD200" d="M0 18h252v90H0z" />
			<path fill="#DE2010" d="M0 36h252v54H0z" />
			<path d="M0 54h252v18H0z" />
			<path d="M4.583 0l84 63-84 63H0V0h4.583z" />
			<path fill="#FFF" d="M0 0l84 63-84 63" />
			<path
				fill="#DE2010"
				d="M46.161 66.045l18.273-12.934-21.029-3.055L34 31l-9.405 19.056-21.029 3.055 18.273 12.934-4.003 19.203L34 76l16.164 9.248z"
			/>
			<path
				fill="#FFC618"
				d="M28.635 55.109c1.976 4.305 2.47 4.588 7.411 6.282 4.94 1.694 18.898 3.3 20.274 3.458-.9-.9-16.621-12.545-19.85-14.875-3.229-2.329-4.129-3.388-4.129-3.388s-2.911-5.24-3.917-6.776c-1.006-1.535-2.858-3.705-5.293-3.705s-3.917 1.429-4.623 3.97c-.388.106-2.47 1.376-2.4 2.682.6-.071 4.376-1.129 5.682 3.141s1.376 11.257.035 14.716c-1.341 3.459-3.423 6.07-3.423 9.105 0 .423.282 1.27.988 1.27.247 1.341 2.223 10.904 2.223 10.904h28.161l4.473-17.292"
			/>
			<g fill="none" stroke="#000" strokeWidth={0.212}>
				<path d="M28.635 55.109c1.976 4.305 2.47 4.588 7.411 6.282 4.94 1.694 18.898 3.3 20.274 3.458-.9-.9-16.621-12.545-19.85-14.875-3.229-2.329-4.129-3.388-4.129-3.388s-2.911-5.24-3.917-6.776c-1.006-1.535-2.858-3.705-5.293-3.705s-3.917 1.429-4.623 3.97c-.388.106-2.47 1.376-2.4 2.682.6-.071 4.376-1.129 5.682 3.141s1.376 11.257.035 14.716c-1.341 3.459-3.423 6.07-3.423 9.105 0 .423.282 1.27.988 1.27.247 1.341 2.223 10.904 2.223 10.904h28.161l4.473-17.292" />
				<path d="M19.39 70.99s5.999-.353 7.623-.353c1.623 0 16.734.019 25.165 1.968" />
				<path d="M21.508 70.871s-.601-.728-.213-2.175c.388-1.447 4.623-5.188 4.623-10.481M25.142 70.637s-.494-2.364 4.905-4.376c1.518-.459 5.858-2.894 5.999-4.87M29.473 66.485s13.243.058 23.724 2.175" />
				<path d="M32.793 64.905s4.551.156 5.292-.056c.741-.212 2.053-.762 2.575-2.313M35.49 64.959s2.434-1.265 2.911-2.911M28.141 81.894s-1.041-7.216-1.253-11.257l2.717 2.594 2.875-2.514 2.472 2.638 2.858-2.425 2.471 2.778 2.83-2.407 2.252 2.618 2.822-2.041 3.355 3.189M50.951 77.345c-10.081-1.444-23.57-1.35-23.57-1.35M22.694 51.052s8.2-3.918 9.647-4.465" />
			</g>
			<g transform="matrix(.21174 0 0 .21174 16 36)" fill="none" stroke="#000">
				<path d="M52.487 177.086l13.018 11.852 11.762-11.762 11.896 12.266 12.846-11.358 11.827 12.43 13.339-11.013 10.897 12.728 13.27-10.145 13.947 12.319" />
				<circle cx={89.425} cy={154.584} r={5.167} />
				<circle cx={111.237} cy={156.047} r={5.167} />
				<circle cx={30.05} cy={16.5} r={4} />
			</g>
		</svg>
	)
}

export default SvgZw
